import React from 'react';
import { generateMonthOptions } from '../shared/constants';

const MonthSelector = ({ value, onChange, className = '' }) => {
	const monthOptions = generateMonthOptions(12);

	return (
		<select
			value={value}
			onChange={(e) => onChange(e.target.value)}
			className={`px-4 py-2 border border-gray-300 rounded-lg font-montserrat focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent ${className}`}>
			{monthOptions.map((option) => (
				<option key={option.value} value={option.value}>
					{option.label}
				</option>
			))}
		</select>
	);
};

export default MonthSelector;
